import { MenuItem, TextField, TextFieldProps, TextFieldVariants } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

export type VariantSelectProps<Variant extends TextFieldVariants = TextFieldVariants> = Omit<
  TextFieldProps<Variant>,
  'children'
> & { label: string; options: { value: string; label: string }[] };

const VariantSelectInner = <Variant extends TextFieldVariants = TextFieldVariants>(
  props: VariantSelectProps<Variant>,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  return (
    <TextField
      ref={ref}
      select
      {...props}
      slotProps={{
        inputLabel: { shrink: true },
      }}
    >
      {props.options.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export const VariantSelect = forwardRef(VariantSelectInner) as <Variant extends TextFieldVariants = TextFieldVariants>(
  props: VariantSelectProps<Variant> & {
    ref?: ForwardedRef<HTMLDivElement>;
  },
) => ReturnType<typeof VariantSelectInner>;
